import type { AppConfig } from './app-config';

const browserOrigin = globalThis.location?.origin?.trim() ?? '';
const isLocalAngularDevServer = /^https?:\/\/(localhost|127\.0\.0\.1)(:\d+)?$/i.test(browserOrigin)
  && browserOrigin.endsWith(':4200');

const resolvedBaseOrigin = isLocalAngularDevServer ? 'http://localhost:3000' : browserOrigin;

export const defaultAppConfig: AppConfig = {
  apiBaseUrl: `${resolvedBaseOrigin}/api/v1`,
  authBaseUrl: `${resolvedBaseOrigin}/api/auth`
};
